export default "__VITE_ASSET__BUuF$Tx3__"